module.exports = __webpack_public_path__ + "img/MB_lobby.b264da88.jpg";